<div class="space-y-6">
  <app-page-header
    [backTo]="['/my-rentals']"
    [backLabel]="'rentals.retourAMesLocations' | t"
  >
    @if (rental(); as r) {
      <div slot="actions" class="flex flex-wrap items-center gap-2">
        @if (canChat()) {
          <button
            type="button"
            (click)="openChat()"
            [disabled]="openingChat()"
            class="inline-flex items-center justify-center gap-2 rounded-lg border border-brand-300 px-4 py-2 text-sm font-medium text-brand-700 transition hover:bg-brand-50 disabled:opacity-50 dark:border-brand-500/40 dark:text-brand-400 dark:hover:bg-brand-500/10"
          >
            @if (openingChat()) { Ouverture… } @else { {{ 'rentals.discuterAvecLeClient' | t }} }
          </button>
        }
        @if (invoiceId() != null) {
          <a
            [routerLink]="['/my-invoices', invoiceId()]"
            class="inline-flex items-center justify-center gap-2 rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 transition hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-white/5"
          >
            {{ 'rentals.voirLaFacture' | t }}
          </a>
        } @else if (!invoiceLoading() && invoiceFetched()) {
          <span class="text-xs text-gray-400">{{ 'rentals.pasDeFacture' | t }}</span>
        }
        <button
          type="button"
          (click)="openDelete()"
          class="inline-flex items-center justify-center gap-2 rounded-lg border border-error-300 px-4 py-2 text-sm font-medium text-error-700 transition hover:bg-error-50 dark:border-error-800 dark:text-error-400 dark:hover:bg-error-500/10"
        >
          {{ 'rentals.supprimer' | t }}
        </button>
      </div>
    }
  </app-page-header>

  @if (chatError()) {
    <div class="rounded-lg border border-warning-200 bg-warning-50 px-4 py-2 text-sm text-warning-700 dark:border-warning-500/30 dark:bg-warning-500/10 dark:text-orange-300">
      {{ chatError() }}
    </div>
  }

  @if (loadError() || loading()) {
    <app-data-state
      [loading]="loading()"
      [error]="loadError()"
      [loadingMessage]="'rentals.chargementDeLaLocation' | t"
      (retry)="fetch()"
    />
  } @else if (rental(); as r) {
    <!-- Barre d'actions du cycle de vie (owner) -->
    @if (hasActions()) {
      <section class="flex flex-wrap items-center gap-2 rounded-2xl border border-gray-200 bg-white p-4 shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03]">
        <span class="mr-1 text-sm font-medium text-gray-700 dark:text-gray-300">Actions :</span>
        @if (canAccept()) {
          <button type="button" (click)="askAccept()"
            class="inline-flex items-center rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white transition hover:bg-brand-600">
            {{ 'rentals.accepterLaDemande' | t }}
          </button>
        }
        @if (canReject()) {
          <button type="button" (click)="askReject()"
            class="inline-flex items-center rounded-lg border border-error-300 px-4 py-2 text-sm font-medium text-error-700 transition hover:bg-error-50 dark:border-error-800 dark:text-error-400 dark:hover:bg-error-500/10">
            Refuser
          </button>
        }
        @if (canStart()) {
          <button type="button" (click)="openScan('start')"
            class="inline-flex items-center gap-2 rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white transition hover:bg-brand-600">
            <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M3 7V5a2 2 0 0 1 2-2h2M17 3h2a2 2 0 0 1 2 2v2M21 17v2a2 2 0 0 1-2 2h-2M7 21H5a2 2 0 0 1-2-2v-2M7 12h10"/></svg>
            {{ 'rentals.scan.startBtn' | t }}
          </button>
          <button type="button" (click)="askStart()"
            class="inline-flex items-center rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-600 transition hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-white/5">
            {{ 'rentals.scan.startManual' | t }}
          </button>
        }
        @if (canFinish()) {
          <button type="button" (click)="openScan('finish')" [disabled]="afterCount() === 0"
            [title]="afterCount() === 0 ? ('rentals.scan.needAfterPhotos' | t) : ''"
            class="inline-flex items-center gap-2 rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white transition hover:bg-brand-600 disabled:cursor-not-allowed disabled:opacity-50">
            <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M3 7V5a2 2 0 0 1 2-2h2M17 3h2a2 2 0 0 1 2 2v2M21 17v2a2 2 0 0 1-2 2h-2M7 21H5a2 2 0 0 1-2-2v-2M7 12h10"/></svg>
            {{ 'rentals.scan.finishBtn' | t }}
          </button>
          <button type="button" (click)="askFinish()" [disabled]="afterCount() === 0"
            class="inline-flex items-center rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-600 transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-white/5">
            {{ 'rentals.scan.finishManual' | t }}
          </button>
        }
        @if (canConfirmCash()) {
          <button type="button" (click)="openCash()"
            class="inline-flex items-center rounded-lg border border-brand-300 px-4 py-2 text-sm font-medium text-brand-700 transition hover:bg-brand-50 dark:border-brand-500/40 dark:text-brand-400 dark:hover:bg-brand-500/10">
            {{ 'rentals.confirmerLePaiementEspeces' | t }}
          </button>
        }
        @if (canCancel()) {
          <button type="button" (click)="askCancel()"
            class="inline-flex items-center rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-600 transition hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-white/5">
            {{ 'rentals.annulerLaLocation' | t }}
          </button>
        }
      </section>
    }

    <!-- Header card : vehicle + status + KPIs -->
    <section class="rounded-2xl border border-gray-200 bg-white p-6 shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03]">
      <div class="flex flex-col gap-5 lg:flex-row lg:items-start lg:justify-between">
        <div class="flex flex-col gap-4 sm:flex-row sm:items-center">
          @if (r.vehicle?.imgCover) {
            <img [src]="r.vehicle?.imgCover" [alt]="vehicleName()" class="h-24 w-36 rounded-xl object-cover ring-1 ring-gray-200 dark:ring-gray-800" />
          } @else {
            <span class="flex h-24 w-36 items-center justify-center rounded-xl bg-gray-100 text-gray-400 dark:bg-gray-800">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor"><path d="M6.5 5.75A1.25 1.25 0 0 0 5.3 6.62l-1.05 3.13H3.75a.75.75 0 0 0-.75.75V14a.75.75 0 0 0 .75.75H4.5v1.5a1.25 1.25 0 1 0 2.5 0v-1.5h10v1.5a1.25 1.25 0 1 0 2.5 0v-1.5h.75A.75.75 0 0 0 21 14v-3.5a.75.75 0 0 0-.75-.75h-.5L18.7 6.62A1.25 1.25 0 0 0 17.5 5.75h-11Z"/></svg>
            </span>
          }
          <div class="space-y-2">
            <div class="flex flex-wrap items-center gap-3">
              <h1 class="text-xl font-semibold text-gray-800 dark:text-white/90">Location #{{ r.id }}</h1>
              <span
                class="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium"
                [class.bg-brand-50]="statusMeta[r.rentalStatusEnum].palette === 'brand'"
                [class.text-brand-700]="statusMeta[r.rentalStatusEnum].palette === 'brand'"
                [class.dark:bg-brand-500/15]="statusMeta[r.rentalStatusEnum].palette === 'brand'"
                [class.dark:text-brand-400]="statusMeta[r.rentalStatusEnum].palette === 'brand'"
                [class.bg-blue-light-50]="statusMeta[r.rentalStatusEnum].palette === 'blue-light'"
                [class.text-blue-light-700]="statusMeta[r.rentalStatusEnum].palette === 'blue-light'"
                [class.dark:bg-blue-light-500/15]="statusMeta[r.rentalStatusEnum].palette === 'blue-light'"
                [class.dark:text-blue-light-400]="statusMeta[r.rentalStatusEnum].palette === 'blue-light'"
                [class.bg-warning-50]="statusMeta[r.rentalStatusEnum].palette === 'warning'"
                [class.text-warning-700]="statusMeta[r.rentalStatusEnum].palette === 'warning'"
                [class.dark:bg-warning-500/15]="statusMeta[r.rentalStatusEnum].palette === 'warning'"
                [class.dark:text-warning-400]="statusMeta[r.rentalStatusEnum].palette === 'warning'"
                [class.bg-gray-100]="statusMeta[r.rentalStatusEnum].palette === 'gray'"
                [class.text-gray-700]="statusMeta[r.rentalStatusEnum].palette === 'gray'"
                [class.dark:bg-gray-800]="statusMeta[r.rentalStatusEnum].palette === 'gray'"
                [class.dark:text-gray-300]="statusMeta[r.rentalStatusEnum].palette === 'gray'"
                [class.bg-error-50]="statusMeta[r.rentalStatusEnum].palette === 'error'"
                [class.text-error-700]="statusMeta[r.rentalStatusEnum].palette === 'error'"
                [class.dark:bg-error-500/15]="statusMeta[r.rentalStatusEnum].palette === 'error'"
                [class.dark:text-error-400]="statusMeta[r.rentalStatusEnum].palette === 'error'"
              >
                {{ statusMeta[r.rentalStatusEnum].label | t }}
              </span>
              @if (r.averageRating != null) {
                <span class="inline-flex items-center gap-1 text-sm text-warning-600 dark:text-warning-400">
                  ★ {{ r.averageRating | number:'1.1-1' }}
                </span>
              }
            </div>
            <p class="text-sm text-gray-600 dark:text-gray-400">
              @if (r.vehicle; as v) {
                <a [routerLink]="['/my-vehicles', v.id]" class="text-brand-600 hover:text-brand-700 dark:text-brand-400">
                  {{ vehicleName() }}
                </a>
                <span class="mx-1.5 text-gray-300 dark:text-gray-600">·</span>
                <span class="font-mono">{{ v.licencePlate || '—' }}</span>
              } @else {
                <span class="text-gray-400">{{ 'rentals.vehiculeNonRenseigne' | t }}</span>
              }
            </p>
            <!-- Pas de carte « Propriétaire » ici : le viewer EST le propriétaire
                 (résidu du fork admin, retiré — #97). -->
          </div>
        </div>
      </div>

      <!-- KPI grid -->
      <div class="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        <div class="rounded-xl border border-gray-200 px-4 py-3 dark:border-gray-800">
          <p class="text-xs text-gray-500 dark:text-gray-400">{{ 'rentals.montantTotal' | t }}</p>
          <p class="mt-1 text-lg font-semibold text-gray-800 dark:text-white/90">
            {{ r.totalCost | number:'1.0-0' }} <span class="text-xs font-normal text-gray-400">XOF</span>
          </p>
        </div>
        <div class="rounded-xl border border-gray-200 px-4 py-3 dark:border-gray-800">
          <p class="text-xs text-gray-500 dark:text-gray-400">{{ 'rentals.duree' | t }}</p>
          <p class="mt-1 text-lg font-semibold text-gray-800 dark:text-white/90">
            @if (durationDays(); as d) { {{ d }} jour(s) } @else { — }
          </p>
          @if (r.nbHours) {
            <p class="text-xs text-gray-400">{{ 'rentals.hoursBilled' | t: { n: r.nbHours } }}</p>
          }
        </div>
        <div class="rounded-xl border border-gray-200 px-4 py-3 dark:border-gray-800">
          <p class="text-xs text-gray-500 dark:text-gray-400">{{ 'rentals.fraisDeRetard' | t }}</p>
          <p class="mt-1 text-lg font-semibold"
             [class.text-error-700]="(r.lateFee ?? 0) > 0"
             [class.dark:text-error-400]="(r.lateFee ?? 0) > 0"
             [class.text-gray-800]="(r.lateFee ?? 0) === 0"
             [class.dark:text-white/90]="(r.lateFee ?? 0) === 0">
            {{ (r.lateFee ?? 0) | number:'1.0-0' }} <span class="text-xs font-normal text-gray-400">XOF</span>
          </p>
        </div>
        <div class="rounded-xl border border-gray-200 px-4 py-3 dark:border-gray-800">
          <p class="text-xs text-gray-500 dark:text-gray-400">{{ 'rentals.contratSigne' | t }}</p>
          <p class="mt-1 text-sm font-medium"
             [class.text-brand-700]="r.docusignSubmissionStatus === 'completed'"
             [class.dark:text-brand-400]="r.docusignSubmissionStatus === 'completed'"
             [class.text-warning-700]="r.docusignSubmissionStatus === 'awaiting'"
             [class.dark:text-warning-400]="r.docusignSubmissionStatus === 'awaiting'"
             [class.text-error-700]="r.docusignSubmissionStatus === 'declined'"
             [class.dark:text-error-400]="r.docusignSubmissionStatus === 'declined'"
             [class.text-gray-400]="!r.docusignSubmissionStatus">
            @switch (r.docusignSubmissionStatus) {
              @case ('completed') { {{ 'rentals.signe' | t }} }
              @case ('awaiting') { En attente }
              @case ('declined') { {{ 'rentals.refuse' | t }} }
              @default { — }
            }
          </p>
        </div>
      </div>
    </section>

    <div class="grid gap-6 lg:grid-cols-2">
      <!-- Période & lieux -->
      <section class="rounded-2xl border border-gray-200 bg-white p-6 shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03]">
        <h2 class="text-base font-semibold text-gray-800 dark:text-white/90">{{ 'rentals.periodeLieux' | t }}</h2>
        <dl class="mt-4 grid gap-3 text-sm">
          <div class="flex justify-between gap-4">
            <dt class="text-gray-500 dark:text-gray-400">{{ 'rentals.debut' | t }}</dt>
            <dd class="text-right text-gray-800 dark:text-white/90">{{ r.startDate | ldate: 'dd/MM/yyyy HH:mm' }}</dd>
          </div>
          <div class="flex justify-between gap-4">
            <dt class="text-gray-500 dark:text-gray-400">{{ 'rentals.finPrevue' | t }}</dt>
            <dd class="text-right text-gray-800 dark:text-white/90">{{ r.endDate | ldate: 'dd/MM/yyyy HH:mm' }}</dd>
          </div>
          @if (r.actualReturnDate) {
            <div class="flex justify-between gap-4">
              <dt class="text-gray-500 dark:text-gray-400">{{ 'rentals.retourReel' | t }}</dt>
              <dd class="text-right" [class.text-error-700]="returnedLate()" [class.dark:text-error-400]="returnedLate()" [class.text-gray-800]="!returnedLate()" [class.dark:text-white/90]="!returnedLate()">
                {{ r.actualReturnDate | ldate: 'dd/MM/yyyy HH:mm' }}
                @if (returnedLate()) { <span class="ml-1 text-xs">(en retard)</span> }
              </dd>
            </div>
          }
          <div class="flex justify-between gap-4 border-t border-gray-100 pt-3 dark:border-gray-800">
            <dt class="text-gray-500 dark:text-gray-400">{{ 'rentals.lieuDePrise' | t }}</dt>
            <dd class="text-right text-gray-800 dark:text-white/90">{{ r.pickupLocation || '—' }}</dd>
          </div>
          <div class="flex justify-between gap-4">
            <dt class="text-gray-500 dark:text-gray-400">{{ 'rentals.lieuDeRetour' | t }}</dt>
            <dd class="text-right text-gray-800 dark:text-white/90">{{ r.returnLocation || '—' }}</dd>
          </div>
        </dl>
      </section>

      <!-- Client -->
      <section class="rounded-2xl border border-gray-200 bg-white p-6 shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03]">
        <h2 class="text-base font-semibold text-gray-800 dark:text-white/90">Client</h2>
        @if (r.customer; as c) {
          <div class="mt-4">
            <!-- noAutoLink : pas de route /users dans l'app owner (fork admin). -->
            <app-user-cell [user]="c.user" [fallbackId]="c.userId" size="md" [noAutoLink]="true" />
            <p class="mt-2 text-xs text-gray-500 dark:text-gray-400">Client #{{ c.id }}</p>
          </div>
          <dl class="mt-4 grid gap-3 text-sm">
            @if (c.licenseNumber) {
              <div class="flex justify-between gap-4">
                <dt class="text-gray-500 dark:text-gray-400">Permis</dt>
                <dd class="text-right font-mono text-gray-800 dark:text-white/90">{{ c.licenseNumber }}</dd>
              </div>
            }
            @if (c.licenseExpiryDate) {
              <div class="flex justify-between gap-4">
                <dt class="text-gray-500 dark:text-gray-400">Expiration permis</dt>
                <dd class="text-right text-gray-800 dark:text-white/90">{{ c.licenseExpiryDate | ldate: 'dd/MM/yyyy' }}</dd>
              </div>
            }
            @if (c.verificationStatus) {
              <div class="flex justify-between gap-4">
                <dt class="text-gray-500 dark:text-gray-400">{{ 'rentals.verification' | t }}</dt>
                <dd class="text-right">
                  <span
                    class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium"
                    [class.bg-brand-50]="c.verificationStatus === 'VERIFIED'"
                    [class.text-brand-700]="c.verificationStatus === 'VERIFIED'"
                    [class.bg-warning-50]="c.verificationStatus === 'PENDING'"
                    [class.text-warning-700]="c.verificationStatus === 'PENDING'"
                    [class.bg-error-50]="c.verificationStatus === 'REJECTED'"
                    [class.text-error-700]="c.verificationStatus === 'REJECTED'"
                  >
                    @switch (c.verificationStatus) {
                      @case ('VERIFIED') { {{ 'rentals.verifie' | t }} }
                      @case ('PENDING') { En attente }
                      @case ('REJECTED') { {{ 'rentals.rejete' | t }} }
                    }
                  </span>
                </dd>
              </div>
            }
            @if (c.city || c.country) {
              <div class="flex justify-between gap-4">
                <dt class="text-gray-500 dark:text-gray-400">Localisation</dt>
                <dd class="text-right text-gray-800 dark:text-white/90">
                  {{ c.city || '' }}{{ c.city && c.country ? ', ' : '' }}{{ c.country || '' }}
                </dd>
              </div>
            }
            @if (c.totalRentals != null) {
              <div class="flex justify-between gap-4">
                <dt class="text-gray-500 dark:text-gray-400">Locations totales</dt>
                <dd class="text-right text-gray-800 dark:text-white/90">{{ c.totalRentals }}</dd>
              </div>
            }
          </dl>
        } @else if (r.userId) {
          <div class="mt-4 space-y-2">
            <p class="text-xs text-gray-500 dark:text-gray-400">{{ 'rentals.reservationLegacySansProfil' | t }}</p>
            <app-user-cell [fallbackId]="r.userId" size="md" />
          </div>
        } @else {
          <p class="mt-4 text-sm text-gray-400">{{ 'rentals.clientNonRenseigne' | t }}</p>
        }
      </section>
    </div>

    <!-- Contrat & signature. Pas de ligne « Lien signature » : le lien DocuSign
         est la session de signature DU CLIENT — personne d'autre ne doit
         l'ouvrir (#97). Seul le contrat signé (rentalContract) est exposé. -->
    @if (r.docusignSubmissionStatus || r.rentalContract || r.qrcode) {
      <section class="rounded-2xl border border-gray-200 bg-white p-6 shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03]">
        <h2 class="text-base font-semibold text-gray-800 dark:text-white/90">{{ 'rentals.contratSignature' | t }}</h2>
        @if (!r.rentalContract && r.docusignSubmissionStatus === 'awaiting') {
          <p class="mt-3 rounded-lg bg-gray-50 px-4 py-3 text-sm text-gray-600 dark:bg-white/[0.03] dark:text-gray-400">
            {{ 'rentals.leContratSeraDisponible' | t }}
          </p>
        }
        <dl class="mt-4 grid gap-3 text-sm sm:grid-cols-2">
          @if (r.docusignSubmissionId) {
            <div class="flex justify-between gap-4">
              <dt class="text-gray-500 dark:text-gray-400">ID soumission</dt>
              <dd class="text-right font-mono text-gray-800 dark:text-white/90">{{ r.docusignSubmissionId }}</dd>
            </div>
          }
          @if (r.rentalContract) {
            <div class="flex justify-between gap-4">
              <dt class="text-gray-500 dark:text-gray-400">{{ 'rentals.contratPdf' | t }}</dt>
              <dd class="text-right">
                <a [href]="r.rentalContract" target="_blank" rel="noopener" class="text-brand-600 hover:text-brand-700 dark:text-brand-400">
                  {{ 'rentals.telecharger' | t }}
                </a>
              </dd>
            </div>
          }
          @if (r.qrcode) {
            <div class="flex justify-between gap-4">
              <dt class="text-gray-500 dark:text-gray-400">QR code</dt>
              <dd class="text-right font-mono text-xs text-gray-700 dark:text-gray-300 break-all">{{ r.qrcode }}</dd>
            </div>
          }
        </dl>
      </section>
    }

    <!-- Remise / restitution : état des lieux (le client photographie au départ, le loueur au retour) -->
    @if (canStart()) {
      <section class="rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03]">
        <h2 class="text-base font-semibold text-gray-800 dark:text-white/90">{{ 'rentals.scan.handoverTitle' | t }}</h2>
        <ol class="mt-3 list-decimal space-y-1.5 pl-5 text-sm text-gray-600 dark:text-gray-300">
          <li>{{ 'rentals.scan.handoverStep1' | t: { count: beforeCount() } }}</li>
          <li>{{ 'rentals.scan.handoverStep2' | t }}</li>
        </ol>
        @if (beforeCount() === 0) {
          <p class="mt-3 rounded-lg bg-warning-50 px-3 py-2 text-sm text-warning-700 dark:bg-warning-500/10 dark:text-warning-400">{{ 'rentals.scan.needBeforePhotos' | t }}</p>
        }
      </section>
    }
    @if (canFinish()) {
      <section class="rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03]">
        <h2 class="text-base font-semibold text-gray-800 dark:text-white/90">{{ 'rentals.scan.returnTitle' | t }}</h2>
        <ol class="mt-3 list-decimal space-y-1.5 pl-5 text-sm text-gray-600 dark:text-gray-300">
          <li>{{ 'rentals.scan.returnStep1' | t: { count: afterCount() } }}</li>
          <li>{{ 'rentals.scan.returnStep2' | t }}</li>
        </ol>
        <label class="mt-4 inline-flex cursor-pointer items-center gap-2 rounded-lg border border-brand-300 px-4 py-2 text-sm font-medium text-brand-700 transition hover:bg-brand-50 dark:border-brand-500/40 dark:text-brand-400">
          <input type="file" accept="image/*" multiple capture="environment" class="sr-only" (change)="uploadAfter($event)" [disabled]="uploadingAfter()" />
          {{ (uploadingAfter() ? 'rentals.scan.uploading' : 'rentals.scan.addAfterPhotos') | t }}
        </label>
        @if (afterError()) {
          <p class="mt-3 rounded-lg bg-error-50 px-3 py-2 text-sm text-error-700 dark:bg-error-500/10 dark:text-error-400">{{ afterError() }}</p>
        }
      </section>
    }

    <!-- Photos avant / après -->
    @if ((r.photosBefore?.length ?? 0) > 0 || (r.photosAfter?.length ?? 0) > 0) {
      <section class="rounded-2xl border border-gray-200 bg-white p-6 shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03]">
        <h2 class="text-base font-semibold text-gray-800 dark:text-white/90">{{ 'rentals.photos' | t }}</h2>
        <div class="mt-4 grid gap-6 lg:grid-cols-2">
          <div>
            <p class="mb-3 text-sm font-medium text-gray-700 dark:text-gray-300">Avant ({{ r.photosBefore?.length ?? 0 }})</p>
            @if ((r.photosBefore?.length ?? 0) === 0) {
              <p class="text-xs text-gray-400">{{ 'rentals.aucunePhoto' | t }}</p>
            } @else {
              <div class="grid grid-cols-3 gap-2 sm:grid-cols-4">
                @for (img of r.photosBefore; track img.id) {
                  <a [href]="img.url" target="_blank" rel="noopener" class="block">
                    <img [src]="img.url" [alt]="'rentals.photoAvant' | t" class="aspect-square w-full rounded-md object-cover ring-1 ring-gray-200 dark:ring-gray-800" />
                  </a>
                }
              </div>
            }
          </div>
          <div>
            <p class="mb-3 text-sm font-medium text-gray-700 dark:text-gray-300">{{ 'rentals.afterCount' | t: { count: r.photosAfter?.length ?? 0 } }}</p>
            @if ((r.photosAfter?.length ?? 0) === 0) {
              <p class="text-xs text-gray-400">{{ 'rentals.aucunePhoto' | t }}</p>
            } @else {
              <div class="grid grid-cols-3 gap-2 sm:grid-cols-4">
                @for (img of r.photosAfter; track img.id) {
                  <a [href]="img.url" target="_blank" rel="noopener" class="block">
                    <img [src]="img.url" [alt]="'rentals.photoApres' | t" class="aspect-square w-full rounded-md object-cover ring-1 ring-gray-200 dark:ring-gray-800" />
                  </a>
                }
              </div>
            }
          </div>
        </div>
      </section>
    }

    <!-- Métadonnées -->
    <section class="rounded-2xl border border-gray-200 bg-white p-6 shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03]">
      <h2 class="text-base font-semibold text-gray-800 dark:text-white/90">{{ 'rentals.metadonnees' | t }}</h2>
      <dl class="mt-4 grid gap-3 text-sm sm:grid-cols-2">
        <div class="flex justify-between gap-4">
          <dt class="text-gray-500 dark:text-gray-400">{{ 'rentals.creeeLe' | t }}</dt>
          <dd class="text-right text-gray-800 dark:text-white/90">{{ r.createdAt | ldate: 'dd/MM/yyyy HH:mm' }}</dd>
        </div>
        @if (r.updatedAt) {
          <div class="flex justify-between gap-4">
            <dt class="text-gray-500 dark:text-gray-400">{{ 'rentals.miseAJour' | t }}</dt>
            <dd class="text-right text-gray-800 dark:text-white/90">{{ r.updatedAt | ldate: 'dd/MM/yyyy HH:mm' }}</dd>
          </div>
        }
      </dl>
    </section>
  }
</div>

<app-confirm-modal
  [open]="deleteOpen()"
  [busy]="deleting()"
  [error]="deleteError()"
  [title]="'rentals.supprimerLaLocation' | t"
  [confirmLabel]="'rentals.supprimerDefinitivement' | t"
  [busyLabel]="'common.deleting' | t"
  danger
  (confirm)="confirmDelete()"
  (close)="closeDelete()"
>
  {{ 'rentals.cetteActionEstIrreversible' | t }} <strong>#{{ rental()?.id }}</strong> {{ 'rentals.seraMarqueeCommeSupprimee' | t }}
</app-confirm-modal>

<!-- Transitions de cycle de vie -->
<app-confirm-modal
  [open]="txOpen()"
  [busy]="txBusy()"
  [error]="txError()"
  [title]="txTitle()"
  [confirmLabel]="txConfirmLabel()"
  [busyLabel]="txBusyLabel()"
  [danger]="txDanger()"
  (confirm)="confirmTx()"
  (close)="closeTx()"
>
  {{ txMessage() | t }}

  <!-- Preview du remboursement (annulation uniquement) -->
  @if (previewLoading()) {
    <p class="mt-3 flex items-center gap-2 text-xs text-gray-500 dark:text-gray-400">
      <svg class="size-3.5 animate-spin" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" class="opacity-25"></circle><path fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" class="opacity-75"></path></svg>
      {{ 'rentals.estimationDuRemboursement' | t }}
    </p>
  } @else if (preview(); as p) {
    <div class="mt-3 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm dark:border-gray-800 dark:bg-white/5">
      <div class="flex items-center justify-between gap-4">
        <span class="text-gray-600 dark:text-gray-400">{{ 'rentals.remboursementEstimeAuClient' | t }}</span>
        <span class="font-semibold text-gray-800 dark:text-white/90">
          {{ p.refundAmount ?? 0 | number:'1.0-0' }} XOF
          @if (p.refundPercentage != null) {
            <span class="ml-1 text-xs font-normal text-gray-500 dark:text-gray-400">({{ p.refundPercentage }} %)</span>
          }
        </span>
      </div>
      @if (p.policyName) {
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">{{ 'rentals.policy' | t }} : {{ p.policyName }}</p>
      }
      @if (p.warning) {
        <p class="mt-1 text-xs text-warning-700 dark:text-warning-400">{{ 'rentals.aucunRemboursementACe' | t }}</p>
      }
    </div>
  } @else if (previewError()) {
    <p class="mt-3 text-xs text-gray-400">{{ previewError() }}</p>
  }
</app-confirm-modal>

<!-- Confirmation paiement espèces -->
<app-modal [isOpen]="cashOpen()" (close)="closeCash()" className="max-w-md p-6">
  <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">{{ 'rentals.confirmerLePaiementEspeces2' | t }}</h3>
  <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
    {{ 'rentals.attestezAvoirRecuLe' | t }} <strong>{{ 'rentals.payee' | t }}</strong> {{ 'rentals.modeEspecesLaCommission' | t }}
  </p>

  @if (cashError()) {
    <div class="mt-4 rounded-lg border border-error-200 bg-error-50 px-3 py-2 text-sm text-error-700 dark:border-error-800 dark:bg-error-500/10 dark:text-error-400">
      {{ cashError() }}
    </div>
  }

  <div class="mt-5">
    <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">{{ 'rentals.referenceDeRecuOptionnel' | t }}</label>
    <input type="text" [formControl]="cashRef" placeholder="ex. REG-2026-000123"
      class="h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/20 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90" />
  </div>

  <div class="mt-5 flex justify-end gap-2">
    <button type="button" (click)="closeCash()" [disabled]="cashBusy()"
      class="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 transition hover:bg-gray-50 disabled:opacity-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-white/5">
      {{ 'rentals.annuler' | t }}
    </button>
    <button type="button" (click)="confirmCash()" [disabled]="cashBusy()"
      class="inline-flex items-center gap-2 rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white transition hover:bg-brand-600 disabled:cursor-not-allowed disabled:opacity-50">
      @if (cashBusy()) {
        <svg class="size-4 animate-spin" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" class="opacity-25"></circle><path fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" class="opacity-75"></path></svg>
        Confirmation…
      } @else { Confirmer l'encaissement }
    </button>
  </div>
</app-modal>

<!-- Résultat d'annulation : remboursement calculé par la politique -->
<app-modal [isOpen]="refundOpen()" (close)="closeRefund()" className="max-w-md p-6">
  @if (refundResult(); as res) {
    <div class="flex items-center gap-3">
      <span class="flex size-10 items-center justify-center rounded-full bg-brand-50 text-brand-600 dark:bg-brand-500/10 dark:text-brand-400">
        <svg class="size-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6 9 17l-5-5" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </span>
      <div>
        <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">{{ 'rentals.locationAnnulee' | t }}</h3>
        @if (res.policyName) {
          <p class="text-xs text-gray-500 dark:text-gray-400">Politique : {{ res.policyName }}</p>
        }
      </div>
    </div>

    <dl class="mt-5 grid gap-3 text-sm">
      @if (res.originalAmount != null) {
        <div class="flex justify-between gap-4">
          <dt class="text-gray-500 dark:text-gray-400">{{ 'rentals.montantInitial' | t }}</dt>
          <dd class="text-right text-gray-800 dark:text-white/90">{{ res.originalAmount | number:'1.0-0' }} XOF</dd>
        </div>
      }
      @if (res.hoursBeforeStart != null) {
        <div class="flex justify-between gap-4">
          <dt class="text-gray-500 dark:text-gray-400">{{ 'rentals.delaiAvantDebut' | t }}</dt>
          <dd class="text-right text-gray-800 dark:text-white/90">{{ res.hoursBeforeStart }} h</dd>
        </div>
      }
      @if (res.cancellationFee != null && res.cancellationFee > 0) {
        <div class="flex justify-between gap-4">
          <dt class="text-gray-500 dark:text-gray-400">Frais d'annulation</dt>
          <dd class="text-right text-gray-800 dark:text-white/90">− {{ res.cancellationFee | number:'1.0-0' }} XOF</dd>
        </div>
      }
      <div class="flex justify-between gap-4 border-t border-gray-100 pt-3 dark:border-gray-800">
        <dt class="text-gray-500 dark:text-gray-400">{{ 'rentals.rembourseAuClient' | t }}</dt>
        <dd class="text-right font-semibold text-gray-800 dark:text-white/90">
          {{ res.refundAmount ?? 0 | number:'1.0-0' }} XOF
          @if (res.refundPercentage != null) {
            <span class="ml-1 text-xs font-normal text-gray-500 dark:text-gray-400">({{ res.refundPercentage }} %)</span>
          }
        </dd>
      </div>
    </dl>

    @if (res.warning) {
      <div class="mt-4 rounded-lg border border-warning-200 bg-warning-50 px-3 py-2 text-sm text-warning-700 dark:border-warning-800 dark:bg-warning-500/10 dark:text-warning-400">
        {{ 'rentals.aucunRemboursementLAnnulation' | t }}
      </div>
    }

    <div class="mt-5 flex justify-end">
      <button type="button" (click)="closeRefund()"
        class="inline-flex items-center gap-2 rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white transition hover:bg-brand-600">
        {{ 'rentals.fermer' | t }}
      </button>
    </div>
  }
</app-modal>

@if (scanOpen(); as kind) {
  <app-qr-scanner
    [title]="kind === 'start' ? 'rentals.scan.startTitle' : 'rentals.scan.finishTitle'"
    [hint]="kind === 'start' ? 'rentals.scan.startHint' : 'rentals.scan.finishHint'"
    [busy]="scanBusy()" [error]="scanError()"
    (scanned)="onScanned($event)" (closed)="closeScan()" />
}
